var _defs, _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEternalTreeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 20.3,
    y1: 15.6,
    x2: 115.4,
    y2: 17,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2db14a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ec964"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 12.8,
    y1: 17,
    x2: 107.5,
    y2: 17,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c753c"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:url(#g1)}.c{fill:url(#g2)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.5 64.2c0 35.1-28.4 63.6-63.5 63.6-35.1 0-63.6-28.5-63.6-63.6 0-35.1 28.5-63.5 63.6-63.5 35.1 0 63.5 28.4 63.5 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m108.8 87.7c-4.1 7.2-9.8 12.8-16.3 16.8q-0.1 0-0.1 0.1c-14.2 8.6-32.7 9.5-48.2 0.6-12.1-6.9-19.9-18.3-22.7-30.9 0 0 11.4 10.4 24.1 8.2q1.8-0.3 3.4-0.8c-1-5.9-0.4-11.9 1.8-17.3-0.3-7-2.8-15.1-11.4-20.3 0 0 9.2 8.4 8.5 16.8 0 0-7 1-9.8-7.8-2.7-8.9-5.8-10.2-8.4-10.1 0 0 16.2-6.6 22.1 9.8 0.8 2.2 1.2 4.6 1.2 7 2.3-3.7 5.2-7 8.9-9.6q-0.3 0.1-0.3 0.1 0 0 0.4-0.2 1.8-1.3 3.9-2.3 0.3-0.2 0.6-0.3c3.1-2.4 6.4-6.4 5.4-12.3 0 0-0.2 6.4-3.8 9 0 0-2.8-2.5-0.2-6.5 2.6-4.1 2.2-5.8 1.2-6.8 0 0 8.1 4.3 3.5 12.1-0.6 1.2-1.5 2.1-2.5 3 3.3-1.1 6.6-1.7 9.9-1.7q0 0 0 0c0 0 2.2-2.6 4.8-2.6 2.6 0 4.7 2.6 4.7 2.6 0 0-2.1 2.6-4.7 2.6-2 0-3.7-1.5-4.4-2.2-3.9 0.3-7.9 1.3-11.6 3.2q-2 1.1-3.7 2.3 1.3-0.5 2.6-0.8c10.7-2 12.3 8.8 12.3 8.8-0.7-1.4-2.4-2.6-8.1-1.3-5.7 1.3-7.3-2.8-7.3-2.8 4.3-3 11.7-0.7 11.7-0.7-6.3-3.5-12.1-1.4-16.1 1.2-4.6 5.2-7.2 11.9-7.5 18.9 0.3-1.3 0.8-2.5 1.5-3.6 6.7-11.2 17.6-4.1 17.6-4.1-1.9-0.5-4.3 0.1-7.6 6.2-3.3 6.1-8.3 4.3-8.3 4.3 0.7-6.2 8.6-11 8.6-11-7.7 2.8-10.5 9.3-11.5 14.8q0.1 0.2 0.1 0.4c8.3-2.7 14.6-6.4 24.4-4.3 10.3 2.1 16.1 11.4 16.1 11.4 0 0-8.6-9-20-7.9-7.6 0.7-13.5 4-18.9 6.7q0.4 1.2 0.9 2.4c2.9 6.3 21.1 20.6 39.3 4.7q1.1-1 2.1-2.1 3.4-3.6 6.1-8.2c12.3-21.4 4.9-48.8-16.6-61.1-4.4-2.5-9-4.2-13.7-5.1 6.4 0.7 12.7 2.7 18.6 6 22.6 13.1 30.5 42 17.4 64.7zm-47.6 15.2c-3.6-3-6.5-7.2-9.2-12.3q-0.6-1.2-1.1-2.5c-4.9 2.1-9.8 3-15.7 0.3 0 0 10.6 11.6 26 14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m102.9 47.7q-1.5-3-3.4-5.6c-5-6.8-10.8-11.4-18.2-14.9-3.6-1.7-7.4-2.8-11.3-3.4-1.5-0.3-3-0.4-4.8-0.6q-0.1 0-0.2 0-0.1 0-0.3 0c-4.8-0.2-9.8 0.4-14.6 1.8q-0.1 0-0.2 0.1-0.3 0.1-0.6 0.2c-3.1 1-6.3 2.4-9.3 4.3-1.8 1.2-3.4 2.4-5 3.6q-0.2 0.2-0.4 0.4-1.9 1.5-3.7 3.4-3.4 3.7-6 8.3c-3.9 6.7-5.8 14.1-5.9 21.4 0.1 4.2 0.5 7.9 1.2 11.2q0.6 2.2 1.3 4.4c1.6 4.3 3.6 8.3 6.3 11.9q0 0 0.1 0.1 0.3 0.5 0.7 0.9 0.1 0.2 0.2 0.3 0.4 0.5 0.8 1 0.2 0.2 0.3 0.3 0.3 0.4 0.6 0.7 0.2 0.2 0.3 0.4 0.5 0.4 0.9 0.9 0 0 0.1 0 0.5 0.6 1 1.1 0.1 0 0.1 0.1 1.1 1 2.2 2 0.4 0.2 0.7 0.5 0.1 0.1 0.2 0.2 0.1 0 0.2 0.1c1.6 1.2 3.2 2.3 4.8 3.2 4.5 2.7 9.3 4.5 14.1 5.5q-4-0.5-7.9-1.6 0 0 0 0-0.1 0-0.2 0-0.3-0.2-0.7-0.3-0.2 0-0.4-0.1-0.4-0.1-0.9-0.3-0.1 0-0.3-0.1-0.4-0.1-0.8-0.3-0.2 0-0.4-0.1-0.3-0.1-0.6-0.2-0.3-0.2-0.6-0.3-0.1 0-0.3-0.1c-10.6-4.4-19.6-12.6-24.7-23.6-3.1-6.6-4.5-13.5-4.5-20.3 0-8.2 2.2-16.5 6.7-24 2.6-4.5 5.9-8.4 9.7-11.7 2.9-2.5 6.2-4.7 9.8-6.5 7.2-3.6 14.8-5.2 22.2-5q0.1 0 0.2 0 0.3 0 0.7 0c7.3 0.3 14.5 2.3 21.2 6 3.6 2 6.9 4.5 9.7 7.2q0.2 0.2 0.3 0.3 0.2 0.2 0.3 0.4c3.7 3.6 6.9 8 9.2 12.9 3 6.1 4.5 12.6 4.7 19-0.6-5.2-2.1-10.3-4.6-15.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEternalTreeActive);
export default __webpack_public_path__ + "static/media/eternal-tree-active.fca02792dd05894586c76900a14d1ba5.svg";
export { ForwardRef as ReactComponent };